module.exports = __webpack_public_path__ + "static/media/c102.dd4501e5.jpg";